import Constants from "./modules/constants";
import Helpers from "./modules/helpers";
import Enums from "./modules/enums";

export default {
    Core: window.Pompeii || {},
    Constants,
    Enums,
    Helpers
}